// extracted by mini-css-extract-plugin
export default {"banner":"ResultSyncFailureBanner_banner__FwvVo","icon":"ResultSyncFailureBanner_icon__4QNvN","link":"ResultSyncFailureBanner_link__qD7x0"};